<template>
 <div id="complete-cut" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
   <div class="modal-content">
    <div class="modal-header">
     <h4 class="modal-title text-left">Completar Corte</h4>
    </div>
    <div class="modal-body">
     <!--
     <sys-form :inputs="formFields"/>
     -->
     <div class="form">
      <div class="form-group row">
       <div class="col-sm-12 text-center">
        <h5 class="text-danger">IMPORTANTE</h5>
        <p class="font-weight-bold">Este proceso confirmará que el corte está correcto y se generarán los registros de pago a Acreedores y Co-Acreedores de tocar en éste corte según Frecuencia de Pago del contrato. De ser capitalizable la inversión se aumentará el capital en cada Anexo.</p>
       </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-center">
          <p class="text-danger" v-if="error">
            {{ error }}
          </p>
        </div>
      </div>
     </div>
    </div>
    <div class="modal-footer">
     <button @click="formHasErrors = false" type="button" class="btn btn-default" data-dismiss="modal">Cancelar</button>
     <button @click="confirmCompleteCut" v-text="buttonText" type="button" class="btn btn-primary"></button>
    </div>
   </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
 </div><!-- /.modal -->
</template>

<script>
import monthlyCutService from '@/services/monthly_cuts'
import sysForm from '../shared/Form'

export default {
  name: 'CompleteMonthlyCut',
  components: { sysForm },
  props: {
    error: null,
    monthly_cut: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      formHasErrors: false
    }
  },
  methods: {
    confirmCompleteCut () {
      if (this.isLoading) {
        return
      }
      this.formHasErrors = false
      this.isLoading = true

      monthlyCutService.complete(this.monthly_cut.id)
        .then(response => {
          if (response.error) {
            this.error = response.error
            this.isLoading = false
          } else {
            this.error = null
            this.isLoading = false
            this.$emit('monthlyCutCompleted')
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.message === 'Unprocessable Entity') {
            this.formHasErrors = true
          }
        })
    }
  },
  computed: {
    buttonText () {
      return this.isLoading ? 'Guardando...' : 'Guardar'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monthly_cuts/CompleteMonthlyCut.vue